import React from 'react';
import {hooks} from '../hooks';
import logoPin from '../assets/bg/location.png';
import {LocationsType} from '../types';

type Props = {
  index: number;
  location: LocationsType;
  isLast: boolean;
};

export const LocationsItem: React.FC<Props> = ({index, location, isLast}) => {
  const navigate = hooks.useNavigate();

  return (
    <li
      key={location.id}
      style={{
        backgroundColor: 'var(--white-color)',
        padding: 10,
        margin: '0 14px 8px 14px',
        marginBottom: isLast ? 0 : 12,
        borderRadius: 10,
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
        borderLeft: `4px solid ${location.isScanned ? '#10b981' : '#f59e0b'}`
      }}
    >
      <section>
        <div className='row-center-space-between'>
          <div style={{
            display: 'flex', 
            alignItems: 'flex-start', 
            gap: 10, 
            flex: 1,
            marginRight: 16
          }}>
            <img
              src={logoPin}
              alt={location.spotName}
              style={{
                width: 16, 
                height: 16, 
                borderRadius: 4, 
                opacity: location.isScanned ? 0.7 : 0.4,
                marginTop: 1
              }}
            />
            <div style={{flex: 1}}>
              <h5 
                style={{
                  color: location.isScanned ? 'var(--main-turquoise)' : '#f59e0b',
                  marginBottom: 6,
                  fontSize: 14,
                  fontWeight: '600',
                  lineHeight: '1.2'
                }}
              >
                {location.spotName}
              </h5>
              
              <div style={{marginBottom: 2}}>
                <span 
                  style={{
                    fontSize: 12,
                    color: 'var(--text-color)',
                    fontWeight: '500',
                    lineHeight: '1.3',
                    display: 'block'
                  }}
                >
                  {location.patrolName}
                </span>
                <span 
                  style={{
                    fontSize: 11,
                    color: 'var(--text-color)',
                    opacity: 0.7,
                    lineHeight: '1.2',
                    display: 'block',
                    marginTop: 2
                  }}
                >
                  {location.groupName}
                </span>
              </div>
            </div>
          </div>
        
          <div style={{
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'flex-end', 
            gap: 4,
            minWidth: 80
          }}>
            <div 
              style={{
                padding: '6px 12px', 
                border: `1px solid ${location.isScanned ? 'rgba(133, 221, 227, 0.5)' : 'rgba(245, 158, 11, 0.3)'}`, 
                borderRadius: 6, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                width: '100%',
                backgroundColor: location.isScanned ? 'rgba(133, 221, 227, 0.1)' : 'rgba(245, 158, 11, 0.1)',
                boxSizing: 'border-box',
              }}
            >
              <h4 
                style={{
                  color: location.isScanned ? 'var(--main-turquoise)' : '#f59e0b', 
                  lineHeight: 1, 
                  fontSize: 13,
                  fontWeight: '600',
                  margin: 0
                }}
              >
                {location.isScanned ? location.formattedTapTime : 'Menunggu'}
              </h4>
            </div>
          </div>
        </div>
          {location.isScanned && location.scannedBy && (
              <div 
                style={{
                  fontSize: 10,
                  color: 'var(--text-color)',
                  opacity: 0.7,
                  textAlign: 'right',
                  lineHeight: 1.2,
                  padding: '4px 0 0 0',
                  marginTop: 2,
                  borderTop: '1px dashed #eee'
                }}
              >
                Dipindai oleh: {location.scannedBy}
              </div>
            )}
      </section>
    </li>
  );
};